"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LineGraph = LineGraph;
var _lib = require("@a1s/lib");
var _curve = require("@visx/curve");
var _xychart = require("@visx/xychart");
var _dateFns = require("date-fns");
var _react = _interopRequireDefault(require("react"));
var _base = require("../../base");
var _components = require("../../components");
var _layout = require("../../layout");
var _animations = require("../../shared/animations");
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
//
// Typescript types
// -------------------------------------------------------------------------------------------------
//
// Mock data
// -------------------------------------------------------------------------------------------------
const line1 = [{
  date: '2021-10-01',
  value: 14506
}, {
  date: '2021-10-02',
  value: 3863
}, {
  date: '2021-10-03',
  value: 3113
}, {
  date: '2021-10-04',
  value: 11633
}, {
  date: '2021-10-05',
  value: 9712
}, {
  date: '2021-10-06',
  value: 10079
}, {
  date: '2021-10-07',
  value: 11395
}, {
  date: '2021-10-08',
  value: 10439
}, {
  date: '2021-10-09',
  value: 4009
}, {
  date: '2021-10-10',
  value: 3398
}, {
  date: '2021-10-11',
  value: 9747
}, {
  date: '2021-10-12',
  value: 10817
}];
const line2 = [{
  date: '2021-10-01',
  value: 200
}, {
  date: '2021-10-02',
  value: 126
}, {
  date: '2021-10-03',
  value: 127
}, {
  date: '2021-10-04',
  value: 209
}, {
  date: '2021-10-05',
  value: 173
}, {
  date: '2021-10-06',
  value: 194
}, {
  date: '2021-10-07',
  value: 370
}, {
  date: '2021-10-08',
  value: 92
}, {
  date: '2021-10-09',
  value: 36
}, {
  date: '2021-10-10',
  value: 53
}, {
  date: '2021-10-11',
  value: 147
}, {
  date: '2021-10-12',
  value: 190
}];

//
// Main component
// -------------------------------------------------------------------------------------------------
/**
 *
 * @alpha
 */
function LineGraph({
  curve = 'rounded',
  data = [line1, line2],
  dateFormat,
  edgeOffsets,
  height,
  lineThicknesses = ['normal', 'thin'],
  testId,
  tooltipShowTime = false,
  width
}) {
  // Accept numbers or strings for the dimension props
  height = (0, _lib.num)(height);
  width = (0, _lib.num)(width);
  const defaultEdgeOffsets = {
    bottom: 25,
    left: 0,
    right: 0,
    top: 25
  };
  const updatedEdgeOffsets = {
    ...defaultEdgeOffsets,
    ...edgeOffsets
  };
  const lineColors = ['blue400', 'pink400'];
  const finalDateFormat = dateFormat || (tooltipShowTime ? 'MMM d hh:mm:ss' : 'MMM d');
  return /*#__PURE__*/_react.default.createElement(_styled.StyledBase, {
    "data-testid": testId
  }, /*#__PURE__*/_react.default.createElement(_xychart.XYChart, {
    height: height || 150,
    margin: updatedEdgeOffsets,
    width: width || 300,
    xScale: {
      type: 'band'
    },
    yScale: {
      type: 'linear'
    }
  }, /*#__PURE__*/_react.default.createElement(_xychart.Grid, {
    className: (0, _styled.gridCSS)(),
    columns: false,
    lineStyle: null,
    numTicks: 4
  }), data === null || data === void 0 ? void 0 : data.map((d, index) => {
    return /*#__PURE__*/_react.default.createElement(_xychart.LineSeries, {
      className: (0, _styled.lineCSS)({
        color: lineColors[index],
        lineThickness: lineThicknesses[index]
      }),
      curve: curve === 'sharp' ? _curve.curveLinear : _curve.curveNatural,
      data: d,
      dataKey: `data${index}`,
      key: `line-series-data${index}`,
      xAccessor: getDate,
      yAccessor: getValue
    });
  }), /*#__PURE__*/_react.default.createElement(_xychart.Tooltip, {
    renderGlyph: renderGlyph,
    showSeriesGlyphs: true,
    snapTooltipToDatumX: true,
    snapTooltipToDatumY: true,
    renderTooltip: renderTooltip(finalDateFormat)
  })));
}

//
// Utility components
// -------------------------------------------------------------------------------------------------

LineGraph.Loadable = Loadable;
function Loadable({
  data,
  height,
  loading,
  width,
  ...props
}) {
  const isLoading = (0, _components.useLoadable)(loading);
  if (!isLoading && data) return /*#__PURE__*/_react.default.createElement(LineGraph, _extends({
    data: data,
    height: height,
    width: width
  }, props));
  return /*#__PURE__*/_react.default.createElement(_base.Box, {
    bg: "$gray300",
    css: {
      animation: `${_animations.pulse} 1.5s linear infinite`,
      height: `${height}px`,
      width: `${width}px`
    },
    r: true
  });
}

//
// Private component
// -------------------------------------------------------------------------------------------------
function DateValueDisplay({
  dateFormat = 'MMM d',
  value
}) {
  return /*#__PURE__*/_react.default.createElement(_layout.Cluster, {
    gap: "2"
  }, /*#__PURE__*/_react.default.createElement(_base.Text, {
    color: "gray400",
    font: "sans",
    size: "sm",
    stretch: "ultraCondensed",
    transform: "uppercase",
    weight: "semibold"
  }, (0, _dateFns.format)(getDate(value), dateFormat)), /*#__PURE__*/_react.default.createElement(_base.Text, {
    color: "gray700",
    font: "sans",
    size: "sm",
    stretch: "ultraCondensed",
    transform: "uppercase",
    weight: "medium"
  }, value.value.toLocaleString(undefined, {
    minimumFractionDigits: 0
  })));
}

//
// Private functions
// -------------------------------------------------------------------------------------------------

function getDate({
  date
}) {
  return new Date(date);
}
function getValue({
  value
}) {
  return value;
}
function renderGlyph({
  key
}) {
  return /*#__PURE__*/_react.default.createElement(_styled.StyledCircle, {
    color: key === 'data0' ? 'blue400' : 'pink400',
    r: "4"
  });
}
function renderTooltip(dateFormat) {
  const Tooltip = ({
    tooltipData: data
  }) => {
    if (!data) return null;
    return /*#__PURE__*/_react.default.createElement(_base.Box, {
      p: "2"
    }, /*#__PURE__*/_react.default.createElement(_layout.Stack, {
      gap: true
    }, Object.entries(data.datumByKey).map(([key, value]) => {
      return /*#__PURE__*/_react.default.createElement(DateValueDisplay, {
        dateFormat: dateFormat,
        key: key,
        value: value.datum
      });
    })));
  };
  return Tooltip;
}